import React, {useEffect, useState} from 'react'
import {Card, Button, Header, Grid, Transition, Message} from "semantic-ui-react";
import '../../style.css'

function TranslationFlashCard(props) {

    const [transition, setTransition] = useState(true);
    const [flip, setFlip] = useState(props.samoanDefault);

    useEffect(() => {
        setTimeout(() => {
            setTransition(true)
        }, 100)
    }, [transition]);


    if (props.startQuiz) {
        setTimeout(() => {
            setFlip(!flip);
        }, props.flipTimer)
    }

    useEffect(() => {
        setFlip(props.samoanDefault)
    }, [props.samoanDefault, props.assignmentNum]);

    const handleFlip = () => {
        if (!props.startQuiz) {
            setTransition(!transition);
            setFlip(!flip)
            setTimeout(() => {
                if (flip) {
                    props.responseAudio.play();
                } else {
                    props.file.play()
                }
            }, 500)
        }
    };

    return (
        <>
            <Message style={{backgroundColor: 'white', border: 'solid', marginRight: 5}} inverted='true'>
                <Transition.Group animation='horizontal flip' duration={500}>
                    {transition &&
                    <Card color='teal' onClick={handleFlip} style={{
                        marginTop: 20,
                        marginBottom: 20,
                        width: 250,
                        height: 225,
                        marginRight: 20,
                        marginLeft: 20,
                        border: '4px solid',
                        borderColor: 'black'
                    }}>
                        {
                            props.pictureActive ?
                                <img src={props.retrievedPictureUrls} className='translationFlashCardPicture'/>
                                :
                                null
                        }

                        <Grid centered>
                            <Grid.Row textAlign='left'>

                            </Grid.Row>
                            <Grid.Row centered>
                                <Grid.Column textAlign='center' style={props.pictureActive ? {marginTop: -20} : {
                                    marginTop: 50,
                                    marginBottom: 1.5
                                }}>
                                    <Card.Description>
                                        {
                                            flip ?
                                                <>
                                                    <Header as='h3' style={{color: 'blue'}}>
                                                        {props.samoanPhrase}
                                                    </Header>
                                                    <br/>
                                                    <Header as='h4' style={{color: 'grey'}}>
                                                        {props.englishQuestion}
                                                    </Header>
                                                </>
                                                :
                                                <>

                                                    <Header as='h3' style={{color: 'blue'}}>
                                                        {props.englishPhrase}
                                                    </Header>
                                                    <br/>
                                                    <Header as='h4' style={{color: 'grey'}}>
                                                        {props.englishResponse}
                                                    </Header>
                                                </>}
                                    </Card.Description>
                                </Grid.Column>
                            </Grid.Row>

                        </Grid>
                    </Card>
                    }
                </Transition.Group>


                <Grid className='center aligned'>
                    <Grid.Row>
                        {!props.translation ?
                            flip ?
                                props.soundActive ?
                                    <Button circular size='massive' className='startQuiz' color='blue'
                                            icon='assistive listening systems'
                                            onClick={() => props.file.play()}/>
                                    :

                                    <Button
                                        circular
                                        className='startQuiz'
                                        size='massive'
                                        color='blue'
                                        icon='assistive listening systems'
                                        disabled
                                    />
                                :
                                props.soundActive ?
                                    <Button
                                        circular
                                        size='massive'
                                        color='blue'
                                        icon='assistive listening systems'
                                        onClick={() => props.responseAudio.play()}

                                    />
                                    :
                                    <Button
                                        circular
                                        className='startQuiz'
                                        size='massive'
                                        color='blue'
                                        icon='assistive listening systems'
                                        disabled
                                    />
                            :
                            flip ?
                                props.soundActive ?
                                    <Button circular size='massive' className='startQuiz' color='blue'
                                            icon='assistive listening systems'
                                            onClick={() => props.file.play()}/>
                                    :
                                    <Button
                                        circular
                                        className='startQuiz'
                                        size='massive'
                                        color='blue'
                                        icon='assistive listening systems'
                                        disabled
                                    />
                                :

                                <Button
                                    circular
                                    className='startQuiz'
                                    size='massive'
                                    color='blue'
                                    icon='assistive listening systems'
                                    disabled
                                />
                        }
                    </Grid.Row>
                </Grid>
            </Message>


        </>
    )
}

TranslationFlashCard.defaultProps = {
    file: 'sb1.mp3',
    responseAudio: 'sb1.mp3',
    englishQuestion: '',
    englishResponse: '',
    soundActive: true,
    pictureActive: false
}

export default TranslationFlashCard
